import { useEffect, useCallback } from 'react';
import removeScript from './remove-script';

const useGoogleLogout = ({ onFailure, onLogoutSuccess }) => {
  const signOut = useCallback(() => {
    if (window.gapi) {
      const auth2 = window.gapi.auth2.getAuthInstance();
      if (auth2 != null) {
        auth2.then(
          () => {
            auth2.signOut().then(() => {
              auth2.disconnect();
              onLogoutSuccess();
            });
          },
          (err) => onFailure(err)
        );
      }
    }
  }, [onLogoutSuccess]);

  useEffect(() => {
    return () => {
      removeScript(document, 'google-api');
    };
  }, []);

  return { signOut };
};

export default useGoogleLogout;
